module.exports = __webpack_public_path__ + "img/05_DSC7708-min.b19e70a3.jpg";